<template>
    <nav>
        <v-layout>
            <v-toolbar id="menu" flat app>
                <v-toolbar-side-icon class="hidden-md-and-up white--text" @click="toggleDrawer" />

                <span v-if="language ==='EN'">
                    <v-btn class="hidden-sm-and-down text-capitalize font-weight-bold" 
                          flat v-for="link in links_EN" 
                          :key="link.text" 
                          @click="$vuetify.goTo(link.href, options)">

                      <span class="menu-btn mr-2">{{ link.text }}</span>
                        </v-btn> 
                </span>

                <span v-if="language ==='UA'">
                    <v-btn class="hidden-sm-and-down text-capitalize font-weight-bold" 
                           flat v-for="link in links_UA" 
                           :key="link.text"
                            @click="$vuetify.goTo(link.href, options)">

                      <span class="menu-btn mr-2">{{ link.text }}</span>
                        </v-btn> 
                </span>

                <span v-if="language ==='RU'">
                    <v-btn class="hidden-sm-and-down text-capitalize font-weight-bold" 
                           flat v-for="link in links_RU" 
                           :key="link.text" 
                           @click="$vuetify.goTo(link.href, options)">
                           
                      <span class="menu-btn mr-2">{{ link.text }}</span>
                        </v-btn>                   
                </span>

                <v-spacer></v-spacer>                      
              <!-- <a v-if="language !=='RU'" class="flag" @click="changeLangTo('RU')"><img src="/img/russian-flag.jpg" width="40"></a>&nbsp;     -->
            <a v-if="language !== 'EN'" class="flag" @click="changeLangTo('EN')"><img src="/img/british-flag.jpg" width="40"></a>&nbsp; 
          <a v-if="language !== 'UA'" class="flag" @click="changeLangTo('UA')"><img src="/img/ukraine-flag.jpg" width="40"></a> 
        </v-toolbar>
      <Drawer :drawer="drawer" />
    </v-layout>
  </nav>
</template>

<script>
    import Drawer from '@/components/Drawer'
    import * as easings from 'vuetify/es5/util/easing-patterns'
    import { MyFunctions } from '@/data/functions.js'

export default {
    name: 'Header',
    components: {
    Drawer
  },
  data () {
    return {
      dialog: false,
      language: '',
      easings: Object.keys(easings),
      drawer: false,
      links_RU: [
        {text: 'Оксана', href: '#oksana'},
        {text: 'Портфолио', href: '#portfolio'},  
        // {text: 'Галерея', href: '#gallery'}, 
        {text: 'Ведущая-конферансье', href: '#ceremony'},
        {text: 'Выступления', href: '#perform'},
        {text: 'Отзывы студентов', href: '#studentsReviews'},
        {text: 'Контакты', href: '#contacts'},
        {text: 'Комментарии и отзывы', href: '#testimonials'}                                                 
      ],
      links_EN: [
        {text: 'Oksana', href: '#oksana'},
        {text: 'Portfolio', href: '#portfolio'},  
        // {text: 'Gallery', href: '#gallery'}, 
        {text: 'Master of Ceremony', href: '#ceremony'},
        {text: 'Performances', href: '#perform'},
        {text: 'Student Reviews', href: '#studentsReviews'},
        {text: 'Contacts', href: '#contacts'},   
        {text: 'Comments & testimoinals', href: '#testimonials'}                                               
      ],
      links_UA: [
        {text: 'Оксана', href: '#oksana'},
        {text: 'Портфоліо', href: '#portfolio'},  
        // {text: 'Галерея', href: '#gallery'}, 
        {text: 'Ведуча-конферансьє', href: '#ceremony'},  
        {text: 'Виконання', href: '#perform'},
        {text: 'Вiдгуки студентiв', href: '#studentsReviews'}, 
        {text: 'Контакты', href: '#contacts'},
        {text: 'Коментарi та вiдгуки', href: '#testimonials'}                                                          
      ],            
    }
  },
  computed: {
    target () {
      const value = this[this.type]
        if (!isNaN(value)) return Number(value)
        else return value
      },
    options () {
      return {
        duration: 900,
        offset: 0,
        easing: 'easeInOutCubic'        
      }
    }
  },
  mounted(){
      this.language = MyFunctions.getLanguage()
  },
  methods: {
      toggleDrawer() {
        this.drawer = !this.drawer
    },
    changeLangTo(lang){
        localStorage.lang = lang   
        location.reload() 
    }
  }
}
</script>

<style>
    #menu {
        opacity: 0.5;
        background-color: #764901;
    }
    .menu-btn {
        color: #fff;
        font-size: 14px;
        font-family: 'Open Sans Condensed', sans-serif!important;
        font-weight: normal!important;
        text-transform: uppercase;
    }
</style>